import styled from '@xstyled/styled-components'

export interface MoteLogoWrapperProps {
  scale?: number
  dropShadow?: string | boolean
  isAnimated?: boolean
}

function hasDropShadow(dropShadow?: string | boolean): boolean {
  return typeof dropShadow === 'string' || dropShadow === true
}

export const MoteLogoWrapper = styled.svgBox<MoteLogoWrapperProps>(
  {
    cursor: 'pointer'
  },
  props =>
    props.isAnimated && {
      transform: 'scale(1)',
      transition: 'transform 100ms ease-in-out',
      '@media (hover: hover)': {
        '&:hover': {
          transform: `scale(${props.scale || 1.2})`
        }
      }
    },
  props =>
    hasDropShadow(props.dropShadow) && {
      filter: `drop-shadow(${
        typeof props.dropShadow === 'string'
          ? props.dropShadow
          : 'rgba(31, 31, 71, 0.2) 0px 10px 15px'
      })`
    }
)
